export namespace ContractMapping {
  export const mapContract = new Map<string, string>([
    ['CF', `CFI`], //CFI:
    ['DC', `Declined`], //Declined:
    ['DE', `DeclineCl`], //DeclineCl:
    ['DH', `DeathClm`], //:: Đã giải quyết Quyền lợi bảo hiểm
    ['IF', `InForce`], //InForce:
    ['INFORCE', `InForce`], //InForce:
    ['LA', `Lapsed`], //Lapsed:
    ['MA', `Matured`], //Matured:
    ['PS', `Proposal`], //Proposal:
    ['PU', `PaidUp`], //PaidUp:
    ['SU', `Surrender`], //Surrender:
    ['WD', `Withdrawn`], //Withdrawn:
    ['PO', `POSTPONE`], //POSTPONE:
    ['RD', `REGDEATH`], //REGDEATH:
    ['TD', `TPDCLAIM`], //TPDCLAIM:
    ['FZ', `FROZEN`], //FROZEN:
    ['PP', `PRMPAYING`], //PRMPAYING:
    ['FP', `FULLYPAID`], //FULLYPAID:
    ['EX', `Expired`], //Expired:
    ['TM', `Terminated`],
    ['AP', `AddPrpsl`],
    ['TR', `Terminated`],
    ['DECLINE_CLAIM', `DECLINE_CLAIM`],
    ['DEATH_CLAIM', 'DEATH_CLAIM'],
    ['TERMINATED', 'TERMINATED'],
    ['Cancelled', 'Cancelled'],
    ['REGDEATH', 'REGDEATH'],
    ['SUSPENDED', 'SUSPENDED'],
    ['TPDCLAIM', 'TPDCLAIM'],
    ['UW', 'Underwriting']
  ])

  export const get = (translator: (val: string) => string) => (key?: string) =>
    key ? translator(mapContract.get(key) || '') ?? '-' : '-'


  export const PolicyLASMessageList = [
    {
      messageCode: 'WN12',
      messageEn: 'Email Actuary for PolAcc',
      messageVi: 'Email cho bộ phận Actuary liên quan đến giá trị hợp đồng.'
    },
    {
      messageCode: 'WN13',
      messageEn: 'Invest/contact CSR team',
      messageVi: 'Email bộ phận Giải quyết khiếu nại (CSR)'
    },
    {
      messageCode: 'WN14',
      messageEn: 'Pay QLDK at Maturity',
      messageVi: 'Yêu cầu chi trả Quyền lợi định kỳ được áp dụng từ ngày đáo hạn của hợp đồng'
    },
    {
      messageCode: 'WN15',
      messageEn: 'Payment transaction notes',
      messageVi: 'Lưu ý giao dịch chi trả'
    }
  ]
}
